import { imageUrl } from '@helpers/image';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './PinboardPreview.styles';
const PinboardPreview = (props) => {
    const image = props.items[0]?.image;
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: props.onClick ? 'button' : 'article', "data-active": props.active, "data-danger": props.danger, onClick: props.onClick },
            React.createElement(S.ImageWrapper, null, image && (React.createElement(S.Image, { alt: "", loading: "lazy", role: "presentation", src: imageUrl(image, { width: 85, height: 85 }) }))),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Title, null, props.title),
                React.createElement(S.Count, null,
                    props.items.length,
                    "\u00A0",
                    props.items.length === 1 ? 'pin' : 'pins'),
                props.contained && (React.createElement(S.Unpin, null,
                    "This item is already pinned to ",
                    React.createElement("strong", null, props.title),
                    ", click to unpin"))))));
};
export default PinboardPreview;
